<template>
    <div class="bulma">
        <div class="modal"
             v-if="show"
             :class="{ 'is-active': show }"
        >

            <div class="modal-background" @click="hideModal"></div>
            <div class="modal-card">

                <header class="modal-card-head announcement-container">
                    <span class="icon has-text-info">
                        <i class="fas fa-info-circle has-text-light fa-lg"></i>
                    </span>
                    <p class="modal-card-title announcement-title">
                        Обновление базы знаний «Атлас24»
                    </p>
                    <button
                        class="delete"
                        aria-label="close"
                        @click="hideModal"
                    ></button>
                </header>

                <section class="modal-card-body announcement-container">
                    <div class="content">
                        <div class="announcement-content">
                            <div class="text">Публичные ссылки на документы, файловое хранилище и многое другое.</div>
                            <a href="https://atlas24.pro/update" target="_blank">Подробнее об обновлении</a>
                            <div class="image-block">
                                <a href="https://atlas24.pro/update" target="_blank">
                                    <img src="/images/announcement.png">
                                </a>
                                <div class="bottomleft">Обновление Атлас24</div>
                                <div class="link">atlas24.pro</div>
                            </div>
                        </div>

                    </div>
                </section>

                <footer class="modal-card-foot">
                    <button
                        class="button"
                        @click="hideModal"
                    >
                        Закрыть
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AnnouncementModal",
    data() {
        return {
            show: true,
            showingNumber: 1,
        }
    },
    mounted() {
        let isShown = this.getCookie('is_shown');
        let showingNumber = this.getCookie('showing_number');

        if (isShown) {
            this.show = false;
            return ;
        }

        if (showingNumber > 2) {
            this.show = false;
            return ;
        }
    },
    methods: {
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        hideModal() {
            let showingNumber = this.getCookie('showing_number');

            if (showingNumber) {
                showingNumber++;
                document.cookie = "showing_number=" + showingNumber + "; Path=/; SameSite=None; Secure; max-age=" + 30*24*60*360;
            } else {
                document.cookie = "showing_number=" + this.showingNumber + "; Path=/; SameSite=None; Secure; max-age=" + 30*24*60*360;
            }

            this.show = false;
            document.cookie = "is_shown=true; max-age=" + 60*60*24 + "; Path=/; SameSite=None; Secure";
        },
    }
}
</script>

<style lang="css" scoped>
.fa-info-circle{
    padding-left: 12px;
    opacity: 0.5;
}
</style>
